export function getLanguageName(tag: string): string {

    const tags = new Map([
        ['de', 'German'],
        ['en', 'English'],
        ['en-gb', 'English (Great Britain)'],
        ['en-us', 'English (United States)'],
        ['es', 'Spanish (Spain)'],
        ['es-mx', 'Spanish (Mexico)'],
        ['fi', 'Finnish'],
        ['fr', 'French'],
        ['it', 'Italian'],
        ['ja', 'Japanese'],
        ['ko', 'Korean'],
        ['nl', 'Dutch'],
        ['pl', 'Polish'],
        ['pt', 'Portuguese (Portugal)'],
        ['pt-br', 'Portuguese (Brazil)'],
        ['ru', 'Russian'],
        ['sr-latn-me', 'dopplernegrin'],
        ['sv', 'Swedish'],
        ['zh-cn', 'Chinese (PRC)'],
        ['zh-tw', 'Chinese (Taiwan)'],
    ]);

    const normalizedTag = tag.trim().toLowerCase();

    const value = tags.get(normalizedTag);
    if (value !== undefined) {
        return value;
    }

    const strippedTag = normalizedTag.split('-')[0];
    if (strippedTag === undefined) {
        return normalizedTag;
    }

    const strippedValue = tags.get(strippedTag);
    if (strippedValue !== undefined) {
        return strippedValue;
    }

    return normalizedTag;
}
